const ViewIconCircle = ({
  width = 24,
  height = 24,
  style = {},
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <circle
        cx="12"
        cy="12"
        r="12"
        fill="url(#paint0_linear_view)"
      />

      <path
        d="M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M12 6C7.8 6 4.35 8.8 3 12.7C4.35 16.6 7.8 19.4 12 19.4C16.2 19.4 19.65 16.6 21 12.7C19.65 8.8 16.2 6 12 6Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <defs>
        <linearGradient
          id="paint0_linear_view"
          x1="12"
          y1="0"
          x2="7.64634"
          y2="25.315"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4A7AF2" />
          <stop offset="1" stopColor="#7BA3F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ViewIconCircle;
